import type { CardButtonProps } from '@jouzen/ecom-components/v3/CardButton';

import type { ArticleImageProps } from '@/app/components/ArticleCardsModule';
import type { ArticleCardDataProps } from '@/app/components/ArticleCardsModule/ArticleCard';

const commonButtonProps: CardButtonProps = {
  ariaLabel: 'press_read_article',
  external: true,
  className: 'bg-neutral-800  text-sandstone-200',
};

export const scienceAndResearchArticleCards = (
  localePartialUrl: string,
): ArticleCardDataProps[] => [
  {
    articleSource: {
      date: 'august_2023',
    },
    buttonProps: {
      ...commonButtonProps,
      href: `https://ouraring.com/blog${localePartialUrl}global-sleeping-patterns-study/`,
    },
    heading: 'science_research_2025_article_one_headline',
    headingClassName: 'mb-6 text-xl md:mb-4 xl:text-heading-sm',
  },
  {
    articleSource: {
      date: 'september_2023',
    },
    buttonProps: {
      ...commonButtonProps,
      href: `https://ouraring.com/blog${localePartialUrl}labor-onset-study-using-oura/`,
    },
    heading: 'science_research_2025_article_two_headline',
    headingClassName: 'mb-6 text-xl md:mb-4 xl:text-heading-sm',
  },
  {
    articleSource: {
      date: 'march_2023',
    },
    buttonProps: {
      ...commonButtonProps,
      href: `https://ouraring.com/blog${localePartialUrl}researchers-use-oura-to-evaluate-physiological-responses-to-covid-19/`,
    },
    heading: 'science_research_2025_article_three_headline',
    headingClassName: 'mb-6 text-xl md:mb-4 xl:text-heading-sm',
  },
];

export const scienceAndResearchArticleImageData = (
  localePartialUrl: string,
): ArticleImageProps => ({
  alt: 'ring_food_alt',
  buttonProps: {
    className: 'text-sandstone-500',
    external: true,
    href: `https://ouraring.com/blog${localePartialUrl}gondor-as-clinical-trial/`,
    label: 'read_more',
    rel: 'noopener noreferrer',
    target: '_blank',
    variant: 'secondary-light',
  },
  heading: 'science_research_2025_highlights_feature_study_headline',
  headingClassname: 'max-w-[80vw]',
  src: 'blue-sky/heart-health/man-sleeping',
});
